import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth()
  
  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
        <p className="ml-4 text-gray-600">Loading...</p>
      </div>
    )
  }
  
  // If not authenticated, redirect to login
  if (!user) {
    console.log('User not authenticated, redirecting to login')
    return <Navigate to="/login" replace />
  }
  
  // If authenticated, render the protected content
  console.log('User authenticated, rendering protected content')
  return children ? children : <Outlet />
}

export default ProtectedRoute